import authCode from './authCode'

const install = function (Vue) {
  Vue.directive('authCode', authCode)
}

if (window.Vue) {
  window['authCode'] = authCode
  Vue.use(install); // eslint-disable-line
}

authCode.install = install
export default authCode
